import { render, staticRenderFns } from "./catelogueAnimate.vue?vue&type=template&id=5ed267fc&scoped=true&"
import script from "./catelogueAnimate.vue?vue&type=script&lang=js&"
export * from "./catelogueAnimate.vue?vue&type=script&lang=js&"
import style0 from "./catelogueAnimate.vue?vue&type=style&index=0&id=5ed267fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed267fc",
  null
  
)

export default component.exports